import React from 'react';
import './CheckoutPage.css';
import ConsiliumLogo from '../assets/images/Consilium-small.png';

const CheckoutCancel: React.FC = () => {
  const handleClose = () => {
    window.close();
    setTimeout(() => {
      window.location.href = 'https://www.civitassignals.com';
    }, 200);
  };

  return (
    <main className="checkout-page">
      <section className="checkout-card cancel">
        <div className="checkout-banner">
          <img
            src={ConsiliumLogo}
            alt="Consilium Premium"
            className="checkout-logo"
            width={160}
            height={40}
          />
          <span className="checkout-tagline">Premium Upgrade Incomplete</span>
        </div>

        <header className="checkout-header">
          <h1>Subscription not completed</h1>
          <p>We didn’t finish upgrading your account.</p>
        </header>

        <div className="checkout-body">
          <p>
            If you still want Premium access, return to the Safescope app and start the upgrade flow
            again. You can re-enter any discount code from the checkout screen.
          </p>
          <p>
            Changed your mind or need assistance? Close this window or reach out to our support
            team— we’re happy to help.
          </p>
        </div>

        <footer className="checkout-actions">
          <button
            type="button"
            className="checkout-action-button primary"
            onClick={handleClose}
          >
            Close this window
          </button>
          <a
            className="checkout-action-button"
            href="mailto:support@civitassignals.com?subject=Checkout%20cancelled"
          >
            Contact Support
          </a>
        </footer>
      </section>
    </main>
  );
};

export default CheckoutCancel;

